import { colors, fonts, layout, spacing } from '../theme';
import { ENTITY_TYPES } from '../constants/entityTypes';

const selectStyle = {
  fontFamily: fonts.body,
  fontSize: '1rem',
  height: '2.25rem',
  minHeight: '44px',
  padding: '0.5rem',
  border: `1px solid ${colors.borderColor}`,
  borderRadius: layout.borderRadius,
  width: '100%',
  boxSizing: 'border-box',
  backgroundColor: colors.white,
  color: colors.darkGray,
};

function EntityTypeSelect({
  label = 'Entity type',
  value,
  onChange,
  required = false,
  error = null,
  disabled = false,
  id = 'entity-type',
  style = {},
}) {
  return (
    <div style={{ marginBottom: spacing.md, ...style }}>
      {label && (
        <label
          htmlFor={id}
          style={{
            display: 'block',
            fontFamily: fonts.heading,
            fontSize: '0.9rem',
            fontWeight: 500,
            marginBottom: spacing.xs,
            color: colors.darkGray,
          }}
        >
          {label}
          {required && <span style={{ color: colors.error, marginLeft: spacing.xs }}>*</span>}
        </label>
      )}
      <select
        id={id}
        value={value || ''}
        onChange={onChange}
        required={required}
        disabled={disabled}
        style={{
          ...selectStyle,
          ...(error ? { borderColor: colors.error } : {}),
        }}
        aria-invalid={error ? 'true' : 'false'}
      >
        <option value="">Select entity type</option>
        {ENTITY_TYPES.map((type) => (
          <option key={type} value={type}>
            {type}
          </option>
        ))}
      </select>
      {error && (
        <div style={{ fontSize: '0.875rem', marginTop: spacing.xs, color: colors.error }} role="alert">
          {error}
        </div>
      )}
    </div>
  );
}

export default EntityTypeSelect;
